/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KpiFarmSetting } from '../../models/kpi-farm-setting';

export interface GetKpiFarmSettingById$Params {
  kpiFarmSettingId: number;
}

export function getKpiFarmSettingById(http: HttpClient, rootUrl: string, params: GetKpiFarmSettingById$Params, context?: HttpContext): Observable<StrictHttpResponse<KpiFarmSetting>> {
  const rb = new RequestBuilder(rootUrl, getKpiFarmSettingById.PATH, 'get');
  if (params) {
    rb.path('kpiFarmSettingId', params.kpiFarmSettingId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KpiFarmSetting>;
    })
  );
}

getKpiFarmSettingById.PATH = '/api/kpisettings/{kpiFarmSettingId}';
